import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function PrivacyPolicy() {
    return (
        <LegalPage
            slug="privacy"
            eyebrow="Legal — 01"
            titleLeft="Privacy"
            titleAccent="Policy."
            counterpart={{ to: "/terms", label: "Terms of Service" }}
        />
    );
}
